/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { AnyAction } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import startCase from "lodash/startCase";
import { Dispatch } from "redux";

export const reducerHandlerFromState = (initialState: { [key: string]: any }, ReducerName: string) => {
    type xState = typeof initialState;

    const xReducers: { [reducer: string]: (draft: Draft<xState>, action: xState) => void } = {};
    const xHandlers: { [handler: string]: (content: string) => (dispatch: Dispatch<AnyAction>) => void } = {};

    Object.keys(initialState).forEach((key: string) => {
        const item = key as Partial<keyof xState>;
        const handlerName = `set${startCase(key).replace(/ /g, "")}`;
        const path = `${ReducerName}/${handlerName}`;

        xReducers[path] = (draft: Draft<xState>, action: xState) => {
            draft[item] = action[item];
        };

        xHandlers[handlerName] = (content: string) => (dispatch: Dispatch<AnyAction>) => {
            dispatch({
                type: path as any,
                [item]: content,
            });
        };
    });

    return { xReducers, xHandlers };
};

export default reducerHandlerFromState;
